export default "__VITE_ASSET__9101e905__"